
import { createAction, props } from '@ngrx/store';

export const loadAdvisorData = createAction('[Data Advisor API] Load Data');
export const loadAdvisorDataSuccess = createAction('[Data Advisor API] Load Data Success', props<any>());
export const loadAdvisorDataFailure = createAction('[Data Advisor API] Load Data Failure', props<any>());
